// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"e92f5a63","633":"e1c0d1c0","657":"998fba70","693":"8467e898","794":"5f30ab59"}[chunkId] + ".chunk.js";
};